export default __webpack_public_path__ + "static/14-8e2a0eecccc3b4613d909cd4387474b5.webp";